import { connect } from 'react-redux';
import FirmwareUpdateDialog from './component';
import {
  loadUpdateFiles, firmwareUpdateWithFile, selectFile, setForceFWUpdate,
} from './actions';

const mapStateToProps = (state) => ({ ...state.firmwareUpdateDialog });

const mapDispatchToProps = (dispatch) => ({
  loadUpdateFiles: () => dispatch(loadUpdateFiles()),
  selectFile: (id) => dispatch(selectFile(id)),
  setForceFWUpdate: (forceUpdate) => dispatch(setForceFWUpdate(forceUpdate)),
  firmwareUpdateWithFile: (file, chargerId, online) => dispatch(firmwareUpdateWithFile(file, chargerId, online)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirmwareUpdateDialog);
